module.exports = __webpack_public_path__ + "img/lemonboy.c625ec6d.jpg";